// removed by extract-text-webpack-plugin
module.exports = {"main":"_2bHSMo_KkoyylxVRhsMooi"};


//////////////////
// WEBPACK FOOTER
// ./components/ReceiptAddress.module.css
// module id = 2364
// module chunks = 1